import * as React from 'react';
import {Icon} from 'semantic-ui-react';

import ConfirmDialog, {EConfirmTarget} from '../Dialogs/ConfirmDialog';
import EmailSubscriptionDialog from '../Dialogs/emails-subscription-dialog/EmailSubscriptionDialog';
import SVGFlag from './SVGFlag';
import JavaMonitoring from '../../components/JavaMonitoring/JavaMonitoring';
import ErrorBoundary from '../../utils/ErrorBoundary';
import PROMTChatBot from 'src/chatbot/PROMTChatBot';

interface AppBarProps {
    logoElement: JSX.Element;

    factoryResetLabel: string;
    factoryResetTooltip: string;
    logoutLabel: string;
    logoutTooltip: string;
    changeLanguageTooltip: string;
    subscriptionTooltip: string;
    switchHeaderMode: boolean;

    onFactoryReset: () => void;
    onLogout: () => void;
    onChangeLanguage: () => void;
    onChangeTableHeader: () => void;
    t: reactI18Next.TranslationFunction;
    hasSupportRole?: boolean;
    onManagementIconClick: () => void;
    hasChatbotRole?: boolean;
}

interface AppBarState {
    isSubscriptionDialogOpen: boolean;
    music: any;
}

export default class AppBar extends React.Component<AppBarProps, AppBarState> {
    constructor(props: AppBarProps) {
        super(props);

        this.state = {
            isSubscriptionDialogOpen: false,
            music: new Audio('./audio/promt.mp3')
        };
    }

    public render() {
        return (
            <div className="app-bar-main">
                <div className="app-bar-flag margin-right--10px bottom-tooltip">
                    <SVGFlag onClick={this.props.onChangeLanguage} />
                    <span className="tooltiptext">{this.props.changeLanguageTooltip}</span>
                </div>

                {this.props.hasChatbotRole && <div className="bottom-tooltip">
                    <PROMTChatBot  />
                </div>}
                <div className="bottom-tooltip">
                    <Icon
                        name='nintendo switch'
                        size='small'
                        circular={true}
                        inverted={true}
                        link={true}
                        onClick={this.props.onChangeTableHeader}
                    />
                    <span className="tooltiptext">
                        {!this.props.switchHeaderMode
                            ? this.props.t('SIDEBAR:ADVANCED_MODE')
                            : this.props.t('SIDEBAR:STANDARD_MODE')
                        }
                    </span>
                </div>

                <div className="bottom-tooltip">
                    <Icon
                        name={'envelope'}
                        size={'small'}
                        circular={true}
                        inverted={true}
                        link={true}
                        onClick={() => this.setState({isSubscriptionDialogOpen: true})}
                    />
                    <span className="tooltiptext">{this.props.subscriptionTooltip}</span>
                </div>
                {this.state.isSubscriptionDialogOpen && <EmailSubscriptionDialog onClose={() => this.setState({isSubscriptionDialogOpen: false})} />}

                <div className="bottom-tooltip">
                    <ConfirmDialog
                        target={EConfirmTarget.FACTORYRESET}
                        trigger={<Icon link={true} circular={true} inverted={true} name={'factory'} size={'small'} />}
                        onConfirm={this.props.onFactoryReset}
                    />
                    <span className="tooltiptext">{this.props.factoryResetTooltip}</span>
                </div>

                {this.props.hasSupportRole &&
                    <ErrorBoundary >
                        <JavaMonitoring />
                    </ErrorBoundary>
                }

                <div className="bottom-tooltip">
                    <Icon
                        name={'dashboard'}
                        size={'small'}
                        circular={true}
                        inverted={true}
                        link={true}
                        onClick={this.props.onManagementIconClick}
                    />
                    <span className="tooltiptext">{this.props.t("SUPPORT_VIEW:MANAGEMENT_VIEW_HINT")}</span>
                </div>
                <div className="margin-right--10px bottom-tooltip">
                    <ConfirmDialog
                        target={EConfirmTarget.LOGOUT}
                        trigger={<Icon link={true} circular={true} inverted={true} name={'log out'} size={'small'} />}
                        onConfirm={this.props.onLogout}
                    />
                    <span className="tooltiptext">{this.props.logoutTooltip}</span>
                </div>

                <div className="app-bar-logo" onMouseOver={() => {this.state.music.play();}} onMouseOut={() => {this.state.music.pause();}}>{this.props.logoElement}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AppBar/AppBar.tsx